import * as React from "react";

function SvgStormly(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="10 150 244 244"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="nonzero">
        <path fill="#FFF" d="M-20-20h600v600H-20z" />
        <g opacity={0.642}>
          <path
            d="M132 366h36.457c2.753-22.719 4.873-38.176 6.358-46.37 1.827-10.08 10.142-27.021 15.685-33.697 3.577-4.308 8.902-11.823 22.043-22.458 9.826-7.952 21.978-15.337 36.457-22.157L234.207 212c-33.412 15.766-58.515 35.312-75.31 58.636-8.386 11.646-13.206 22.282-17.898 38.158-3.565 12.06-6.565 31.13-8.999 57.206z"
            fill="#51E7B6"
          />
          <path
            d="M79 366h39.278c2.203-33.89 5.616-56.32 10.24-67.29 5.376-12.757 10.63-24.139 23.914-40.357 8.856-10.812 23.712-24.451 44.568-40.919L174.819 189c-37.766 28.207-63.057 54.147-75.871 77.818C86.134 290.488 79.484 323.55 79 366z"
            fill="#372ED6"
          />
          <path
            d="M27 365h39.278c-.367-39.033 6.183-71.223 19.648-96.567 13.465-25.345 30.49-46.127 51.074-62.346L113.475 179c-23.804 20.667-38.95 35.388-45.437 44.164-8.155 11.033-11.595 15.213-16.923 25.904C39.077 273.228 31.04 311.871 27 365z"
            fill="#372ED6"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgStormly);
